/**
 * Collection sidebar: find an artist by name and jump to their works.
 */
(function () {
  var root = document.querySelector("[data-artist-finder]");
  if (!root) return;

  var input = root.querySelector("[data-artist-finder-input]");
  var list = root.querySelector("[data-artist-finder-list]");
  var indexEl = root.querySelector("[data-artist-finder-index]");
  if (!input || !list || !indexEl) return;

  var artists = [];
  try {
    artists = JSON.parse(indexEl.textContent || "[]");
  } catch (e) {
    artists = [];
  }
  if (!artists.length) {
    root.hidden = true;
    return;
  }

  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function hideList() {
    list.hidden = true;
    list.innerHTML = "";
    input.setAttribute("aria-expanded", "false");
  }

  function showMatches(query) {
    var q = norm(query);
    list.innerHTML = "";
    if (!q || q.length < 1) {
      hideList();
      return;
    }

    var matches = [];
    for (var i = 0; i < artists.length; i++) {
      var a = artists[i];
      if (norm(a.name).indexOf(q) !== -1) matches.push(a);
      if (matches.length >= 8) break;
    }

    if (!matches.length) {
      var empty = document.createElement("div");
      empty.className = "artist-finder-empty";
      empty.textContent = "No artists match “" + query.trim() + "”";
      list.appendChild(empty);
      list.hidden = false;
      input.setAttribute("aria-expanded", "true");
      return;
    }

    matches.forEach(function (a, idx) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "artist-finder-option";
      btn.setAttribute("role", "option");
      btn.setAttribute("data-index", String(idx));
      btn.innerHTML =
        '<span class="artist-finder-option-name"></span>' +
        '<span class="artist-finder-option-go">View works →</span>';
      btn.querySelector(".artist-finder-option-name").textContent = a.name;
      btn.addEventListener("click", function () {
        window.location.href = a.url;
      });
      list.appendChild(btn);
    });
    list.hidden = false;
    input.setAttribute("aria-expanded", "true");
  }

  var timer = null;
  input.addEventListener("input", function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      showMatches(input.value);
    }, 50);
  });

  input.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      hideList();
      input.blur();
      return;
    }
    if (event.key === "Enter") {
      event.preventDefault();
      var first = list.querySelector(".artist-finder-option");
      if (first) first.click();
      else {
        var q = input.value.trim();
        if (q) window.location.href = "/pages/artists?q=" + encodeURIComponent(q);
      }
    }
  });

  document.addEventListener("click", function (event) {
    if (!root.contains(event.target)) hideList();
  });
})();
